import { render, staticRenderFns } from "./Refaccion.vue?vue&type=template&id=f3b5ba9a&"
import script from "./Refaccion.vue?vue&type=script&lang=js&"
export * from "./Refaccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports